/**
 * Progress bar for the quota in a usage cell.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import './UsageCell.css'
import './UsageQuotaProgressBar.css'

export interface QuotaProgressBarProps {
  is_alert: boolean
  percent: number
}

const QuotaProgressBar = (props: QuotaProgressBarProps) => {
  const fixed_percent = Math.max(0, Math.min(props.percent, 100))

  return (
    <div className="quota-progress-bar">
      <div>
        quota:{' '}
        <span className={`quota-label-value${props.is_alert ? ' alert' : ''}`}>
          {fixed_percent}% used
        </span>
      </div>

      <div className="progress-bar-container">
        <div className="progress-bar-background"></div>
        <div
          className={`progress-bar-value${props.is_alert ? ' alert' : ''}`}
          style={{ width: `${fixed_percent}%` }}
        ></div>
      </div>
    </div>
  )
}

export default QuotaProgressBar
